import React, { FC } from "react";

import { Footer } from "@websential/cosmic";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material";

export interface IAccountLayout {
  contents?: React.ReactNode;
}

export const AccountLayout: FC<IAccountLayout> = ({
  contents,
}: IAccountLayout) => {
  const theme = useTheme();
  const testId = "account-layout";
  const onTaxslipsClickedHandler = () => {
    window.open('https://www.taxslips.com/', '_self');
  }
  // console.log('import.meta.env.BASE_URL', import.meta.env.BASE_URL)
  return (
    <Grid container>
      <Grid
        container
        direction="column"
        alignItems="center"
        size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
        sx={{ backgroundColor: theme.palette.primary.main }}
      >
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            height: "40vh",
          }}
          data-testid={testId + "-logo"}
        >
          <img
            src={`${import.meta.env.BASE_URL !== "/" ? import.meta.env.BASE_URL : ""}/images/logo-light.png`}
            alt="loading"
            width="100%"
            onClick={onTaxslipsClickedHandler}
            style={{ cursor: "pointer" }}
          />
        </Grid>
        <Grid
          sx={{
            height: "60vh",
            display: "flex",
            alignItems: "flex-end",
          }}
          data-testid={testId + "-bottomImage"}
        >
          <img
            src={`${import.meta.env.BASE_URL !== "/" ? import.meta.env.BASE_URL : ""}/images/left-bottom-img.jpg`}
            alt="loading"
            width="100%"
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        alignItems="center"
        size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
      >
        <Grid
          container
          sx={{
            height: "90vh",
            display: "flex",
            alignItems: "center",
          }}
          data-testid={testId + "-content"}
        >
          {contents}
        </Grid>
        {/* <Grid
          item
          sx={{
            height: "10vh",
            display: "flex",
            alignItems: "flex-end",
          }}
          data-testid={testId + "-footer"}
        >
          <Footer />
        </Grid> */}
      </Grid>
    </Grid>
  );
};
